import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setError(true));
  }, [slug]);

  if (error) return <div className="container-soft py-24 text-center" style={{ color: "var(--text-secondary)" }}>Post not found.</div>;
  if (!post) return <div className="container-soft py-24 text-center" style={{ color: "var(--text-secondary)" }}>Loading…</div>;

  return (
    <article className="container-soft py-16 md:py-24 max-w-3xl" data-testid="blog-detail-page">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm mb-8" style={{ color: "var(--primary-deep)" }} data-testid="blog-back-link">
        <ArrowLeft size={14}/> Back to all articles
      </Link>
      <div className="text-xs uppercase tracking-[0.25em] mb-4" style={{ color: "var(--primary-deep)" }}>{post.category}</div>
      <h1 className="font-display text-4xl sm:text-5xl mb-6" style={{ color: "var(--text-primary)" }}>{post.title}</h1>
      {post.cover_image && <img src={post.cover_image} alt="" className="w-full rounded-3xl mb-10 aspect-[16/9] object-cover"/>}
      <div className="text-lg leading-relaxed whitespace-pre-line" style={{ color: "var(--text-secondary)" }}>{post.content}</div>
    </article>
  );
}
